// extracted by mini-css-extract-plugin
export var pillWrapper = "_qs-0";
export var showOverflow = "_qs-1";